import {createQuillEditor} from "src/decidim/decidim_awesome/editors/editor"

export default createQuillEditor;